/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-10-18 16:21:51
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-09-12 14:24:13
 */

import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js'
import md5 from 'js-md5'
import { PUBLIC_KEY } from '../../../../global-constant.js'
// import {Md5} from 'ts-md5'
/**
 * @description 转换树形结构菜单
 * @param menuList 菜单列表
 * @author ****
 */
const getTreeMenus = (menuList) =>
  menuList
    .filter((item) => item.menuType !== 3 && !!item.path)
    .map((v) => {
      const temp = JSON.parse(JSON.stringify(v))
      return {
        ...temp,
        children: v.children ? getTreeMenus(v.children) : []
      }
    })

// 密钥对生成 http://web.chacuo.net/netrsakeypair
const publicKey = PUBLIC_KEY
const privateKey = ''
// const privateKey = 'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAqhHyZfSsYourNxaY\n' +
// '7Nt+PrgrxkiA50efORdI5U5lsW79MmFnusUA355oaSXcLhu5xxB38SMSyP2KvuKN\n' +
// 'PuH3owIDAQABAkAfoiLyL+Z4lf4Myxk6xUDgLaWGximj20CUf+5BKKnlrK+Ed8gA\n' +
// 'kM0HqoTt2UZwA5E2MzS4EI2gjfQhz5X28uqxAiEA3wNFxfrCZlSZHb0gn2zDpWow\n' +
// 'cSxQAgiCstxGUoOqlW8CIQDDOerGKH5OmCJ4Z21v+F25WaHYPxCFMvwxpcw99Ecv\n' +
// 'DQIgIdhDTIqD2jfYjPTY8Jj3EDGPbH2HHuffvflECt3Ek60CIQCFRlCkHpi7hthh\n' +
// 'YhovyloRYsM+IS9h/0BzlEAuO0ktMQIgSPT3aFAgJYwKpqRYKlLDVcflZFCKY7u3\n' +
// 'UP8iWi1Qw0Y='
const encrypt = (text) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(text) // 对数据进行加密
}
const decrypt = (text) => {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(text) // 对数据进行解密
}

// 回显数据字典
const selectDictLabel = (data, value) => {
  if (value === undefined) {
    return ''
  }
  const actions = []
  Object.keys(data).some((key) => {
    if (data[key].value === `${value}`) {
      actions.push(data[key].label)
      return true
    }
    return false
  })
  if (actions.length === 0) {
    actions.push(value)
  }
  return actions.join('')
}
const protocolIsHttps = () => {
  return window.location.protocol === 'https'
}
const getHost = () => {
  return window.location.host
}

/**
 * 字符权限校验
 * @param {Array} value
 *  @param {Array} list 权限码集合
 * @returns {Boolean}
 */
const checkPermi = (value, list) => {
  if (value && value.length > 0 && list.length > 0) {
    const permissions = list
    const permissionDatas = value
    const allPermission = '*:*:*'

    const hasPermission = permissions.some((permission) => {
      return allPermission === permission || permission === permissionDatas
    })
    if (!hasPermission) {
      return false
    }
    return true
  }
  console.error('need roles! Like checkPermi="[\'system:user:add', 'system:user:edit\']"')
  return false
}
export { md5, selectDictLabel, encrypt, decrypt, getTreeMenus, protocolIsHttps, getHost, checkPermi }
